import ComboboxPhongNamHoc from "./ComboboxPhongNamHoc";
import SelectBoxPhongNamHocMultiple from "./SelectBoxPhongNamHocMultiple";

export default ComboboxPhongNamHoc
export { SelectBoxPhongNamHocMultiple }